import SvgIcon from '@home/components/SvgIcon';
import BubbleCommon from '@op/components/BubbleCommon';
import { DBO_U } from '@op/utils/format';
import useIntls from '@opm/hooks/useIntls';
import React from 'react';

export default function URLShare({
  url,
  className,
  iconClassName,
  tips = 'Go to original post',
  btnText,
  onClick,
}: {
  url: string;
  className?: string;
  iconClassName?: string;
  tips?: string;
  btnText?: string | JSX.Element;
  onClick?: () => void;
}) {
  const { intl } = useIntls();

  return (
    <div
      className={className}
      onClick={(e) => {
        if (onClick) return onClick();

        e.stopPropagation();
        DBO_U.open(url);
      }}
    >
      <BubbleCommon
        showIcon={false}
        tipsMap={null}
        placement="top"
        content={intl(tips)}
      >
        <SvgIcon type="other-share-icon" className={iconClassName} />
        {btnText}
      </BubbleCommon>
    </div>
  );
}
